import { render, staticRenderFns } from "./MedalPage.vue?vue&type=template&id=720d28af&scoped=true"
import script from "./MedalPage.vue?vue&type=script&lang=js"
export * from "./MedalPage.vue?vue&type=script&lang=js"
import style0 from "./MedalPage.vue?vue&type=style&index=0&id=720d28af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720d28af",
  null
  
)

export default component.exports